export default {
  name: 'dn-link-group',

  props: {
    type: {
      type: String,
      default: 'list',
    },
    title: {
      type: Boolean,
      default: true,
    },
    category: {
      type: String,
      required: true,
    },
    group: {
      type: String,
      required: true,
    },
    onlyLatestLabel: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    isList() {
      return this.type === 'list';
    },
    isBlock() {
      return this.type === 'block';
    },
    computedGroup() {
      return this.$store.getters['navigation/categoryGroup'](this.category, this.group);
    },
    computedLinks() {
      const group = this.computedGroup;
      if (!group) return [];

      if (this.isList) return group.links;

      const links = group.links.slice();
      links.sort((a, b) => {
        if (a.created && b.created) {
          if (a.created.timestamp > b.created.timestamp) return -1;
          if (a.created.timestamp < b.created.timestamp) return 1;
          return -1;
        }
        if (a.created) return -1;
        if (b.created) return 1;
        return 0;
      });
      return links;
    },
    updateLabelSeparator() {
      return this.isBlock ? '' : ' ';
    },
  },

  render(h) {
    const group = this.computedGroup;
    if (!group) return;

    const links = this.computedLinks;
    let { label } = group;
    const $children = [];
    let isBlock = this.isBlock;

    if (label == null && this.group == "investigation") {
      label = '判定を確認して出願する大学を検討する'
      isBlock = false;
    }

    if (this.title) {
      $children.push(h('h3', {
        staticClass: 'dn-link-group__title',
        class: {
          'dn-heading-3': this.isList,
        },
        domProps: {
          innerHTML: label + (isBlock ? ' 関連ページ' : ''),
        },
      }));
    }

    const $links = links.filter(link => {
      return !link.data.groupIndex && link.data.groupIndex !== '';
    }).map((link, index) => {
      const $update = link.publishState && (!this.onlyLatestLabel || link.created.latest) ? h('span', {
        staticClass: 'dn-link-group__update-label',
        class: {
          'dn-link-group__update-latest': link.created.latest,
        },
      }, link[link.publishState].shortLabel + this.updateLabelSeparator +(link.publishState === 'created' ? '公開' : '更新')) : null;

      const $icon = h('span', {
        staticClass: 'dn-link-group__icon',
      }, [h('dn-icon', { props: { icon: 'arrow-right' } })])

      const $label = h('span', {
        staticClass: 'dn-link-group__label',
        domProps: {
          innerHTML: link.label,
        },
      });

      const domProps = {
        href: link.href,
      };

      if (link.target) {
        domProps.target = link.target;
      }

      const labelWrapChildren = [$icon, $label];
      let linkChildren;
      if (this.isList) {
        linkChildren = labelWrapChildren;
      } else {
        linkChildren = [h('span', {
          staticClass: 'dn-link-group__label-wrap',
        }, labelWrapChildren)];
        // $update && linkChildren.push($update);
      }

      const $link = h('a', {
        staticClass: 'dn-link-group__link',
        class: {
          'dn-link-group__link--matched': link.matched,
        },
        domProps,
      }, linkChildren);

      const children = [$link];
      // this.isList && $update && children.push($update);

      return h('li', {
        staticClass: 'dn-link-group__item',
        key: index,
      }, children);
    });

    $children.push(h('ul', {
      staticClass: 'dn-link-group__links',
    }, $links));

    if (this.$slots.default) {
      $children.push(h('div', {
        staticClass: 'dn-link-group__footer',
      }, this.$slots.default));
    }

    return h('div', {
      staticClass: 'dn-link-group',
      class: {
        ['dn-link-group--' + this.type]: true,
      },
    }, $children);
  },
}



// WEBPACK FOOTER //
// ./src/js/ui/components/navigations/LinkGroup.js